var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M408.2,360.4V189.5H96.8v170.9c0,20.2,16.3,36.5,36.5,36.5h238.4 C391.9,396.9,408.2,380.6,408.2,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M408.2,189.5v170.9c0,10.4-4.4,19.8-11.3,26.4c-6.6,6.3-15.4,10.1-25.2,10.1H133.3 c-9.8,0-18.7-3.8-25.2-10.1c-7-6.7-11.3-16-11.3-26.4V189.5H408.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M231.6,95.4L96.8,189.5l155.7,108.7l155.6-108.7L273.4,95.4C260.8,86.6,244.1,86.6,231.6,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M408.1,189.5l-40.1,28l-115.5,80.7l-115.7-80.7l-40-28l40-28l56.4-39.4l38.4-26.8 c12.5-8.8,29.2-8.8,41.8,0l38.4,26.8l56.4,39.4L408.1,189.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M368.1,137.9v79.6l-115.6,80.7l-115.7-80.7V138c0-8.7,7.1-15.8,15.8-15.8h199.7 C361,122.2,368.1,129.2,368.1,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M396.9,386.8c-6.6,6.3-15.4,10.1-25.2,10.1H133.3c-9.8,0-18.7-3.8-25.2-10.1l120-107.6 c13.9-12.4,34.8-12.4,48.7,0L396.9,386.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M194.5,175.6c-1,0.8-1.5,1.9-1.5,3.3c0,1.4,0.6,2.5,1.9,3.3c1.2,0.8,4.1,1.8,8.6,2.9 c4.5,1.1,7.9,2.8,10.4,5s3.7,5.4,3.7,9.6c0,4.2-1.6,7.7-4.8,10.3s-7.3,3.9-12.5,3.9c-7.5,0-14.2-2.8-20.2-8.3l6.3-7.7 c5.1,4.4,9.8,6.7,14.1,6.7c1.9,0,3.4-0.4,4.6-1.2c1.1-0.8,1.7-2,1.7-3.4s-0.6-2.5-1.8-3.4c-1.2-0.8-3.5-1.7-6.9-2.5 c-5.5-1.3-9.5-3-12-5.1s-3.8-5.4-3.8-9.8c0-4.5,1.6-7.9,4.8-10.4c3.2-2.4,7.2-3.6,12-3.6c3.1,0,6.3,0.5,9.4,1.6 c3.1,1.1,5.9,2.6,8.2,4.6l-5.3,7.7c-4.1-3.1-8.3-4.7-12.7-4.7C196.9,174.3,195.5,174.8,194.5,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M268.7,183.7L256,209.5h-6.3L237,183.7v29.7h-10.5v-47.1h14.2l12.1,25.9l12.2-25.9h14.2v47.1h-10.5 V183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M301.8,175.6c-1,0.8-1.5,1.9-1.5,3.3c0,1.4,0.6,2.5,1.9,3.3c1.2,0.8,4.1,1.8,8.6,2.9 c4.5,1.1,7.9,2.8,10.4,5s3.7,5.4,3.7,9.6c0,4.2-1.6,7.7-4.8,10.3c-3.2,2.6-7.3,3.9-12.5,3.9c-7.5,0-14.2-2.8-20.2-8.3l6.3-7.7 c5.1,4.4,9.8,6.7,14.1,6.7c1.9,0,3.4-0.4,4.6-1.2c1.1-0.8,1.7-2,1.7-3.4s-0.6-2.5-1.8-3.4c-1.2-0.8-3.5-1.7-6.9-2.5 c-5.5-1.3-9.5-3-12-5.1s-3.8-5.4-3.8-9.8c0-4.5,1.6-7.9,4.8-10.4c3.2-2.4,7.2-3.6,12-3.6c3.1,0,6.3,0.5,9.4,1.6s5.9,2.6,8.2,4.6 l-5.3,7.7c-4.1-3.1-8.3-4.7-12.7-4.7C304.2,174.3,302.8,174.8,301.8,175.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.3b6d9b14377b3e80f6381673d2fdb355.svg";
export { ForwardRef as ReactComponent };